import { Button, Row, Space, Tooltip } from "antd";
import React, { act, useContext, useEffect, useState } from "react";
import { ColumnComponent } from "../../components/ui";
import DataContext from "../../context/DataContext";
import { useParams } from "react-router-dom";
import AuthContext from "../../context/AuthContext";
import { DownloadOutlined } from "@ant-design/icons";
import { MultipleSelect, SearchInput } from "../../components/functional";
import { CustomerProps } from "../../interfaces/interfaces";
import { Card } from "antd/lib";
import { exportCustomerFile } from "../../utils/func/ExportFile";
import { CustomerDrawer, CustomerTable } from "../../components/customer";
import QuickbooksContext from "../../context/QuickbooksContext";

export const CustomerListPage = () => {
  const { idClient } = useParams();
  const { handleGetQbData, qbLoading } = useContext(QuickbooksContext);
  const { getClientInformation } = useContext(AuthContext);
  const {
    getData: getListData,
    customerOptions,
    customerByClient,
    getCustomersListByClient,
    getCustomersListByClientPaginated,
  } = useContext(DataContext);
  const [selectedRowsToEdit, setSelectedRowToEdit] = useState<React.Key[]>([]);
  const [customerDrawerStatus, setCustomerDrawerStatus] = useState<{
    open: boolean;
    idCustomer: string | null;
  }>({ open: false, idCustomer: "" });
  const [idProject, setIdProject] = useState<string | null>(null);

  useEffect(() => {
    if (idClient) {
      getListData("customer", idClient);
      getListData("projects", idClient, undefined, { active: true });
      getListData("users", idClient);
      getListData("project-templates", idClient, undefined, { active: true });
      getCustomersListByClient({ idClient });
      getClientInformation(idClient, () => {});
    }
  }, [idClient]);

  const onChangeSelectedRowsToEdit = (newSelectedRowToEdit: React.Key[]) => {
    setSelectedRowToEdit(newSelectedRowToEdit);
  };

  const rowSelection = {
    selectedRowKeys: selectedRowsToEdit,
    onChange: onChangeSelectedRowsToEdit,
  };

  return (
    <>
      <Row gutter={[24, 0]}>
        <ColumnComponent>
          <Card
            className="summary-client__card"
            styles={{ body: { display: "none" } }}
            actions={[
              <Space direction="vertical" size={0} style={{ width: "100%" }}>
                <label>Filter By Customer</label>
                <Tooltip title="Filter By Customer">
                  <MultipleSelect
                    placeholder="Customer"
                    className="summary-client__card__actions__select"
                    options={customerOptions}
                    onSelect={(values) => {
                      let query = values.length > 0 ? values : null;
                      idClient &&
                        getCustomersListByClientPaginated({
                          idClient,
                          filters: {
                            customer: query,
                            active: true,
                          },
                        });
                    }}
                  />
                </Tooltip>
              </Space>,
              <Space direction="vertical" size={0} style={{ width: "100%" }}>
                <label>Search Customer</label>
                <SearchInput
                  onSearch={(value: string) => {
                    if (value) {
                      idClient &&
                        getCustomersListByClientPaginated({
                          idClient,
                          filters: {
                            active: true,
                          },
                          search: value,
                        });
                    } else {
                      idClient &&
                        getCustomersListByClientPaginated({
                          idClient,
                          filters: {
                            active: true,
                          },
                          search: value,
                        });
                    }
                  }}
                />
              </Space>,

              <Space direction="vertical" size={0}>
                <label>Actions</label>
                <Space
                  direction="horizontal"
                  size={0}
                  style={{ width: "100%" }}
                >
                  <Tooltip
                    title={
                      selectedRowsToEdit.length > 0
                        ? "Export Selected Data"
                        : "Export Data"
                    }
                    placement="left"
                  >
                    <Button
                      type="link"
                      icon={<DownloadOutlined />}
                      size="large"
                      onClick={() => {
                        exportCustomerFile(
                          customerByClient,
                          selectedRowsToEdit as string[],
                        );
                      }}
                    />
                  </Tooltip>
                  <Button
                    style={{
                      backgroundColor: "#2CA01C",
                      color: "#FFF",
                      borderColor: "#2CA01C",
                    }}
                    loading={qbLoading}
                    size="small"
                    onClick={() =>
                      idClient &&
                      handleGetQbData(idClient, () =>
                        getListData("projects", idClient),
                      )
                    }
                  >
                    Sync with QuickBooks
                  </Button>
                </Space>
              </Space>,
            ]}
          />
        </ColumnComponent>

        <ColumnComponent>
          <CustomerTable
            idClient={idClient ? idClient : ""}
            onSelectOne={(record: CustomerProps, idProject?: string) => {
              setCustomerDrawerStatus({ open: true, idCustomer: record._id });
              if (idProject) {
                setIdProject(idProject);
              } else {
                setIdProject(null);
              }
            }}
            rowSelection={rowSelection}
            onChangePage={(page, pageSize) =>
              idClient &&
              getCustomersListByClientPaginated({
                idClient,
                filters: {
                  active: true,
                  page: page,
                  perPage: pageSize,
                },
              })
            }
          />
        </ColumnComponent>
      </Row>
      {idClient && (
        <CustomerDrawer
          open={customerDrawerStatus.open}
          idClient={idClient}
          idCustomer={customerDrawerStatus.idCustomer}
          onSelectOne={(record: CustomerProps) =>
            setCustomerDrawerStatus({ open: true, idCustomer: record._id })
          }
          onClose={() =>
            setCustomerDrawerStatus({ open: false, idCustomer: "" })
          }
          projectPreselected={idProject}
        />
      )}
    </>
  );
};
